// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3f7eed0f","455":"a6bb4627","977":"84006ee6"}[chunkId] + ".chunk.js";
};